let intervalId = -1
const $loading = document.createElement("DIV")
$loading.classList.add("global-loading")

export default {
    /**
     * Hide the loading message.
     */
    hide: function () {
        const $body = document.querySelector("body")

        $body.removeChild($loading)
    },

    /**
     * Show the loading message.
     *
     * @param {string} message Message
     */
    show: function (message) {
        const $body = document.querySelector("body")

        $loading.innerHTML = `<strong>${message}</strong>`

        $body.appendChild($loading)
    },

    /**
     * Show the loading message, then hide it after a give number of ms.
     *
     * @param {number} duration Duration in milliseconds
     * @param {string} message Message
     */
    run: function (duration, message) {
        if (intervalId === -1) {
            this.show(message)

            intervalId = setInterval(() => {
                intervalId = -1

                this.hide()
            }, duration)
        }
    }
}



// WEBPACK FOOTER //
// ./src/utilities/loading-manager.js